module.exports = __webpack_public_path__ + "img/mf.11614fc4.svg";